import React from "react";
import { useField } from "formik";
import { CustomSelect } from "customField/partials/fields/CustomSelect";
import { CustomFieldSchemaFragment, Option } from "__generated__/graphql";
import { CustomListSelectField } from "customField/partials/fields/CustomListSelectField";

interface IFormikPreviewFormSelectProps {
  name: string;
  labelledById?: string;
  schema?: CustomFieldSchemaFragment | null;
  listView?: boolean;
}
export const FormikPreviewFormSelect: React.FC<
  IFormikPreviewFormSelectProps
> = ({ name, labelledById, schema, listView }) => {
  const [field, meta, helpers] = useField<string>({
    name,
  });

  const setValue = (value: Option | null) => {
    value && helpers.setValue(JSON.stringify(value));
  };
  const value = field.value ? (JSON.parse(field.value) as Option) : null;

  if (listView) {
    return (
      <CustomListSelectField
        value={value}
        setValue={(value) => setValue(value)}
        labelledById={labelledById}
        schema={schema}
      />
    );
  }

  return (
    <CustomSelect
      value={value}
      setValue={(value) => setValue(value)}
      labelledById={labelledById}
      schema={schema}
      errorMessage={meta.error}
      touched={meta.touched}
    />
  );
};
